import { z } from 'zod';

export const addressDocumentSchema = z.object({
  name: z.string().min(1),
  phone: z.string().min(1),
  city_locality: z.string().min(1),
  country_code: z.string().min(1),
  postal_code: z.string().min(1),
  address_line1: z.string().min(1),
  address_line2: z.string().optional(),
  state_province: z.string().default(''),
  is_default: z.boolean().optional().default(false),
  is_shop_location: z.boolean().optional(),
});

export type AddressDocument = z.infer<typeof addressDocumentSchema>;

/**
 * In-flight address shape used inside checkout while the user is still
 * entering data. Phone may be `''` until the standalone phone field is filled
 * (Stripe's AddressElement is configured to NOT collect phone, so verification
 * fires as soon as the address itself is complete — before phone is typed).
 *
 * The strict `addressDocumentSchema.parse(...)` MUST be called at the boundary
 * into order creation (e.g., `InformationSection.onSubmit`) before treating
 * a draft as a final `AddressDocument`. Structurally identical to
 * `AddressDocument` for TypeScript; the alias exists to make the looser
 * runtime invariant visible in function signatures.
 */
export type AddressDocumentDraft = Omit<AddressDocument, 'phone'> & {
  phone: string;
};
